import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g><path d=\"M26.6666 5H35V13.3333\" stroke=\"white\" stroke-width=\"3.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.66663 33.3333L35 5\" stroke=\"white\" stroke-width=\"3.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M35 26.6665V34.9998H26.6666\" stroke=\"white\" stroke-width=\"3.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M25 25L35 35\" stroke=\"white\" stroke-width=\"3.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.66663 6.6665L15 14.9998\" stroke=\"white\" stroke-width=\"3.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g>", 1)
  ])))
}
export default { render: render }